import PATH from "constants/path";
import { getInfoResponse, getUserLocal, clearLocalStorage } from "utils/common";
import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SERVICE } from "constants/global";
import userAPI from "api/userAPI";
import noticeAPI from "api/noticeAPI";

const logout = createAsyncThunk(
  "LOG_OUT",
  async (_arg, { rejectWithValue }) => {
    try {
      await userAPI.logout();
      clearLocalStorage();
      location.href = PATH.TOP;
      return;
    } catch (error) {
      clearLocalStorage();
      location.href = PATH.TOP;
      return rejectWithValue(error);
    }
  }
);

const saveUserInfo = createAction("SAVE_USER_INFO");
const clearCheckToken = createAction("CLEAR_CHECK_TOKEN");
const checkToken = createAsyncThunk(
  "CHECK_TOKEN",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      const res = await userAPI.checkToken();
      dispatch(saveUserInfo(getInfoResponse(res)));
      return;
    } catch (error) {
      return rejectWithValue(error.data.message);
    }
  }
);

const getUser = createAsyncThunk(
  "GET_USER",
  async (_arg, { dispatch, rejectWithValue }) => {
    try {
      let isInLine = false;
      const res = await Promise.all([
        userAPI.getUser(),
        noticeAPI.getInitNotice({ service: SERVICE }),
      ]);
      dispatch(saveUserInfo(getInfoResponse(res[0])));
      if(res[0].sorrypage == '0' || res?.[1].sorrypage == '0') {
        return {
          monitor: {},
          notice: {},
          isInLine: true
        };
      }
      return {
        monitor: res[0].data.monitor,
        notice: res[1].message?.notice,
        isInLine: res[0].data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const userLocal = getUserLocal();
const initialUserDisplay = {
  id: userLocal ? userLocal?.id : "",
  name: userLocal ? userLocal?.name : "",
  point: userLocal ? userLocal?.point : 0,
};
const initialState = {
  user: null,
  isAuth: null,
  userDisplay: initialUserDisplay,
  noticesInit: null,
  isCheck: null,
  isInLine: false
};

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: {
    // GET USER - NOTICE
    [getUser.fulfilled]: (state, action) => {
      state.user = action.payload.monitor;
      state.noticesInit = action.payload.notice;
      state.isInLine = action.payload.isInLine;
    },

    // CHECK TOKEN
    [checkToken.fulfilled]: (state) => {
      state.isCheck = true;
    },

    [clearCheckToken]: (state) => {
      state.isCheck = null;
    },

    [saveUserInfo]: (state, action) => {
      if (action.payload) {
        state.userDisplay = action.payload
        state.isAuth = true;
      } else {
        state.userDisplay = initialUserDisplay;
        state.isAuth = false;
        state.isInLine = true;
        clearLocalStorage();
      }
    },
  },
});

const { reducer } = userSlice;
export { getUser, logout, checkToken, clearCheckToken, saveUserInfo };
export default reducer;
